import 'fetch-polyfill';
import API from '../../APIconfig';
import {
  DELETE_SAVED_CARD,
  LIST_SAVED_CARDS
} from './CardsConstants';
import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError
} from '../async/asyncActions';

import {
  toastr
} from 'react-redux-toastr';

export const deleteStoredCard = (cardToken, csrfRequestIdentifier, token) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart('Deleting Stored Card...', true, 'deletecard'));
      const URL = `${API.savedcards.deleteCard.url}`;
      const reqObject = {
        method: API.savedcards.deleteCard.method,
        credentials: 'include',
        mode: 'cors',
        body: JSON.stringify({
          cardToken
        }),
        headers: new Headers({
          'Content-type': 'application/json',
          csrfRequestIdentifier,
          fcChannel: API.fcChannel,
          token,
        }),
      };

      const deleteCard = await fetch(URL, reqObject).then(response => response.json());
      
      dispatch({
        type: DELETE_SAVED_CARD,
        payload: deleteCard,
      });

      if (deleteCard.deleted) {
        toastr.success('Stored Cards', 'Successfully deleted card');
        dispatch(listStoredCards(csrfRequestIdentifier, token));
      } else {
        toastr.error('Stored Cards', `Failed to delete card, ${deleteCard.errorMessage}`);
        dispatch(asyncActionFinish());
      }
    } catch (error) {
      dispatch(asyncActionError(error));
    }
  }
}

export const listStoredCards = (csrfRequestIdentifier, token) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart('Fetching Stored Cards . . .', true, 'liststoredcards'));
      const URL = `${API.savedcards.getStoredCards.url}?paymentPurpose=GVLoad`;
      const reqObject = {
        method: API.savedcards.getStoredCards.method,
        credentials: 'include',
        mode: 'cors',
        headers: new Headers({
          'Content-type': 'application/json',
          csrfRequestIdentifier,
          fcChannel: API.fcChannel,
          token,
        }),
      };

      const fetchedCards = await fetch(URL, reqObject).then(response => response.json());

      if (fetchedCards.cards && Array.isArray(fetchedCards.cards)) {
        if (fetchedCards.errorMessage !== 'Success') {
          toastr.error('Stored Cards Error', fetchedCards.errorMessage);
        }
      } else {
        toastr.error('Stored Cards Error', `Unable to fetch stored cards. ${fetchedCards.errorMessage || ''}`);
      }


      dispatch({
        type: LIST_SAVED_CARDS,
        payload: fetchedCards,
      });
      
      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError(error));
    }
  };
};